/**
 *
 * @package Demo classif
 * @version 2.0.0
 * @author : eudes evrard<eudes.bobbohebo@cyclope.ai>
 * @name : <BOBBOH-EBO>
 * @language :  Typescript / EcmaScript x /  React / Redux
 * Copyright (c) 2018-present, All rights reserved . 
 * 
 */
import * as fromRootModels from '@root-models/index';
import * as React from 'react';



/* Component that catch JavaScript error anywhere in 
 * child component tree
 * Component ErrorBoundaries
 * @return React.Component
 */
export class ErrorBoundaries extends React.Component<any, fromRootModels.ErrorsBoundariesInterface<string,boolean>>{

    constructor(props: any){

        super(props);

        this.state = {

            error: "", 
            errorInfo: "" ,
            hasError: false,
            
        }
        
    }

    public componentDidCatch(errors: any, errorInfos: any): any{

       this.setState({
            error: errors,
            errorInfo: errorInfos
        })

    }
    
    public render() {

        if (this.state.errorInfo) {

            return (
                <div className="ErrorBoundaries wrapper" style={{overflow:'hidden', position:'relative', width: '100%', height: '100%'}}>
                    <div className="Boundarie">
                        <main  style={{padding: '10px' , margin:'20% auto 0', width:'50%', height:'auto'}}>
                            <h1  style={{marginBottom: '40px ',textAlign: 'center',color: '#555' , margin:'0'}}><span  style={{   font: 'bold 150% sans-serif'}}>JavaScript error</span></h1>
                            <p style={{textAlign: 'center',color: '#555', font: 'bold 40px sans-serif' , margin:'0'}}>***</p>
                            <p style={{textAlign: 'center',color: '#555' , font: 'normal 120% sans-serif' }}>A JavaScript error occurred in the main process,</p>
                            <p style={{textAlign: 'center',color: '#777', font: 'normal 120% sans-serif' , margin:'0'}}>* Maybe object's proporties are change.</p>
                            <p style={{textAlign: 'center',color: '#777', font: 'normal 120% sans-serif' , margin:'0'}}>* Send us an e-mail about this error or try again in a minute.</p>
                            <nav  style={{marginTop: '35px', textAlign: 'center'  }}>
                                <a href="mailto:support@cyclope.ai" style={{ textDecoration:'none', font: 'normal 110% sans-serif'}}>support@cyclope.ai</a>
                            </nav>
                        </main>
                    </div>
                </div>
            )

        }
        
        return(

            this.props.children
        )
    }
}


// WEBPACK FOOTER //
// ./src/root/errors/index.tsx